import { apiCall } from "../imports"

const PREFIX = "shop/promotions"

export default {

    getPromotions(data) {
        return apiCall('get', `${PREFIX}`, data)
    },

    createPromotion(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    updatePromotion(promotionID, data) {
        return apiCall('patch', `${PREFIX}/${promotionID}`, data)
    },

    deletePromotion(promotionID) {
        return apiCall('delete', `${PREFIX}/${promotionID}`)
    }
}